/**
 * KAN-867 (RD-SUB-033) — a company can be LOCKED while its Stripe subscription is HEALTHY
 * (the lock lagged a payment, or the two disagree). Paying cannot unlock that, so the screens
 * self-heal once and then point at support. Pure; UX only — the server decides access.
 */
const HEALTHY_BASES = new Set(['active', 'trial_subscribed', 'change_scheduled', 'cancel_pending']);

/** @returns {boolean} locked level (read-only / suspended) + Stripe-linked + a healthy billing base. */
export function isHealthyButLocked({ level, stripeLinked, base }) {
  return (level === 'read_only' || level === 'suspended') && stripeLinked === true && HEALTHY_BASES.has(base);
}

export default isHealthyButLocked;
